interface eqxEventHandler {
    id: string
    callback: Function
}
export class eqxEvent {
    name: string
    isPreventDefault: boolean = false
    params: any
    context: any
    promise?: Promise<any>

    constructor(name: string, params: any, context: any) {
        this.name = name
        this.params = params
        this.context = context
    }
    preventDefault() {
        this.isPreventDefault = true
    }
    setReturnValue(promise: Promise<any>) {
        this.promise = promise
    }
    getReturnValue() {
        return this.promise
    }
}
export default class eqxEventBroker {
    log: Function = console.log
    events: {[key: string]: eqxEventHandler[]} = {}
    context?: any
    name?: string

    constructor(context?: any, name?: string) {
        this.context = context
        //name is used for logging
        this.name = name ?? context?.constructor.name
        if (!this.name) name = '[eqxEventBroker]'
    }
    on(event: string, callback: Function, id?: string) {
        const name = this.name
        this.log(name + ': Event observer added', event, id)
        this.events[event] = this.events[event] ?? []
        //get a random number to use as an id
        id = id ?? Math.random().toString(36).substring(7)
        this.removeEvent(event, id)
        this.events[event].push({id: id, callback: callback})
        return id
    }
    trigger(eventName: string, args?: any) {
        const name = this.name
        this.log(name + ': Event triggered', eventName, args)
        const eventObj = new eqxEvent(eventName, args, this.context)
        this.events[eventName] = this.events[eventName] ?? []
        this.events[eventName].forEach((event) => {
            const callback = event.callback
            this.log(name + ': Triggering  event', event.id)
            if (!args) args = []
            callback.apply(eventObj, args)
        })
        return eventObj
    }
    removeEvent(event: string, id: string) {
        const name = this.name
        this.log(name + ': Removing App event', event, id)
        this.events[event] = this.events[event] ?? []
        //remove the event with the matching id
        this.events[event] = this.events[event].filter((item) => item.id !== id)
    }
}
